import {defineMessages} from 'react-intl';

export default defineMessages({
	copyright: {
		id: 'footer.copyright',
		defaultMessage: 'Calzaturificio Casadei SpA © {year} All Rights Reserved',
	},
});
